import { withStyles } from "@mui/styles";
import React from "react";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import { IconButton, Grid, Tooltip } from "@mui/material";
// import { Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Typography } from "@mui/material";
import download from '../images/download-doc.svg';
import spinner from "../../assign-prescriptions/images/spinner.gif";
import Avatar from "@mui/material/Avatar";
import moment from "moment-timezone";
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';
// import DeleteIcon from '@mui/icons-material/Delete';
import VerticalMenu from "./ActionCellRenderer";

const styles = theme => ({
  root: {
    width: '100%',
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10',
  },
  padding10px: {
    padding: '8px',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    }
  },
  removepadding: {
    padding: '0px !important'
  }
});

const TransactionSortObj = {
  name: { tableName: '', sortColumn: 'name' },
  username: { tableName: '', sortColumn: 'username' },
  accountname: { tableName: 'accounts', sortColumn: 'name' },
  phone: { tableName: 'contacts', sortColumn: 'phone' },
  is_enabled: { tableName: '', sortColumn: 'is_enabled' },
  created_on: { tableName: '', sortColumn: 'created_on' },
  last_login_on: { tableName: '', sortColumn: 'last_login_on' },
}

let TransactionFilterObj = {
  searchObject: null,
  created_on: {
    fromdate: '',
    todate: ''
  },
  last_login_on: {
    fromdate: '',
    todate: ''
  },
  pageNo: 0,
  pageSize: 25,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
class UserInactiveReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loader: false,
      rowsPerPage: 25,
      data: [],
      isButtonDisabled: false,
      cellCheckboxesSelected: [],
      isHeaderChecked: false,
      openUserDeleteDialog: false,
      userDeletionArr: [],
      selectedRowId: null,
      selected: []
    };
  }

  convertToTimeZone = (requestDate) => {
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return date
      .tz(zone.substring(zone.lastIndexOf(" ") + 1))
      .format("MM/DD/YYYY hh:mm:ss A");
  };

  exportCSV = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "CSV/InActiveUserReport", {
      method: "POST",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(TransactionFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRows = [];
        let columns = [
          [
            "ID",
            "Name",
            "UserName",
            "Associated Account",
            "Phone",
            "Created On",
            "LastLogin On",
            "Status",
          ],
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== "undefined") {
          if (result && result.length > 0) {
            for (let i of result) {
              columns.push([
                i.name,
                i.username,
                i.accountname,
                i.phone,
                i.created_on ? this.convertToTimeZone(i && i.created_on) : "",
                i.last_login_on
                  ? this.convertToTimeZone(i && i.last_login_on)
                  : "",
                i.is_enabled === "true" || i.is_enabled === true
                  ? "Enabled"
                  : "Disabled",
              ]);
            }
          }

          for (let i of columns) {
            csvRows.push(i.join(","));
          }
          let csvString = csvRows.join("%0A");
          let element = document.createElement("a");
          element.href = "data:attachment/csv." + csvString;
          element.target = "_Blank";
          element.download = "InActiveUsersReport.csv";
          document.body.appendChild(element);
          element.click();
        }
      });
  };

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource()
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.created_on.fromdate = '';
      TransactionFilterObj.created_on.todate = '';
      TransactionFilterObj.last_login_on.fromdate = '';
      TransactionFilterObj.last_login_on.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = () => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set fromdate and todate
        if (filterObject.created_on) {
          const dateValue = filterObject.created_on;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.created_on.fromdate = date1
              TransactionFilterObj.created_on.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.created_on.fromdate = date1
              TransactionFilterObj.created_on.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.created_on.fromdate = date
              TransactionFilterObj.created_on.todate = ''
            } else {
              TransactionFilterObj.created_on.todate = date
              TransactionFilterObj.created_on.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.created_on.todate = '';
          TransactionFilterObj.created_on.fromdate = ''
        }

        // to set fromdate and todate
        if (filterObject.last_login_on) {
          const dateValue = filterObject.last_login_on;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.last_login_on.fromdate = date1
              TransactionFilterObj.last_login_on.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.last_login_on.fromdate = date1
              TransactionFilterObj.last_login_on.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.last_login_on.fromdate = date
              TransactionFilterObj.last_login_on.todate = ''
            } else {
              TransactionFilterObj.last_login_on.todate = date
              TransactionFilterObj.last_login_on.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.last_login_on.todate = '';
          TransactionFilterObj.last_login_on.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }
        apiCall()

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'inactiveuserreports', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results, isButtonDisabled: false })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], isButtonDisabled: true })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  PictureCellRenderer = (params) => {
    return <Avatar alt="" src={params.data.picture_url} />
  }

  StatusCellRenderer = (t) => {
    return (params) => {
      return (params.value === true || params.value === "true") ? t("Report.inActive.Enabled") : t("Report.inActive.Disabled")
    }
  }

  ActionCellRenderer = (t, classes, data) => {
    return (params) => {
      return (
        <VerticalMenu
          t={t}
          classes={classes}
          contextData={params.data}
          data={data}
          api={this.gridApi}
        />
      )
    }
  }

  // CheckboxCellRenderer = (params) => {
  //   return (
  //     <Checkbox
  //       checked={params.node.selected}
  //       sx={{ "&.Mui-checked": { color: "#0ae" } }}
  //     />
  //   )
  // }

  // CheckboxHeaderComponent = (params) => {
  //   return (
  //     <Checkbox
  //       checked={this.state.selected.length === 25}
  //       indeterminate={this.state.selected.length > 0 && this.state.selected.length < 25}
  //       onChange={(e) => this.handleHeaderCheckboxChange(e, params)}
  //       sx={{ "&.Mui-checked": { color: "#0ae" }, '&.MuiCheckbox-indeterminate': { color: '#0ae' } }}
  //     />
  //   )
  // }

  // handleHeaderCheckboxChange = (event, params) => {
  //   const isHeaderChecked = event.target.checked
  //   this.setState({ isHeaderChecked })
  //   if (isHeaderChecked) {
  //     params.api.getRenderedNodes().map((node) => {
  //       node.setSelected(true)
  //       return node
  //     })
  //     this.setState((state) => ({ selected: state.data.map(n => n.id) }))
  //   } else {
  //     params.api.getRenderedNodes().map((node) => {
  //       node.setSelected(false)
  //       return node
  //     })
  //     this.setState({ selected: [] })
  //   }
  // }

  // onPageChanged = (params) => {
  //   params.api.deselectAll();
  //   this.setState({ isHeaderChecked: false, selected: [] })
  // }

  // onRowSelected = (params) => {
  //   console.log("on row selected")
  //   if (!(params.api.getRenderedNodes().length === params.api.getSelectedNodes().length)) {
  //     params.api.refreshCells({ force: true })
  //     let selectedNodes = params.api.getSelectedNodes()
  //     if (selectedNodes.length > 0) {
  //       if (selectedNodes.length === 1) {
  //         console.log('selected nodes 1')
  //         this.setState({ selected: [selectedNodes[0].data.id], selectedRowId: selectedNodes[0].data.id })
  //       } else {
  //         console.log('selected nodes > 0')
  //         let selected = selectedNodes.map(node => node.data.id)
  //         this.setState({ selected: selected, selectedRowId: null })
  //       }
  //     }
  //   }
  // }

  // handleConfirmDelete = () => {
  //   console.log(this.state.selectedRowId)
  //   if (this.state && this.state.selectedRowId) {
  //     console.log('for single')
  //     this.setState({
  //       openUserDeleteDialog: true,
  //       userDeletionArr:
  //         this.state &&
  //         this.state.data.filter((x) => x.id === this.state.selectedRowId),
  //     });
  //   } else {
  //     console.log('for multi')
  //     this.setState({
  //       openUserDeleteDialog: true,
  //       userDeletionArr:
  //         this.state &&
  //         this.state.data.filter(
  //           (x) => this.state && this.state.selected.indexOf(x.id) > -1
  //         ),
  //     });
  //   }
  // };

  // handleConfirmClose = (event) => {
  //   if (this.state && this.state.selectedRowId) {
  //     this.setState({
  //       openUserDeleteDialog: false,
  //       selectedRowId: null,
  //       userDeletionArr: [],
  //       selected: [],
  //     });
  //   } else
  //     this.setState({
  //       openUserDeleteDialog: false,
  //       selectedRowId: null,
  //       userDeletionArr: [],
  //       selected: [],
  //     });
  //   this.gridApi.deselectAll();
  // };

  // handleDeleteConfirmed = (event) => {
  //   if (this.state && this.state.selectedRowId) {
  //     console.log('single delete')
  //     this.handleDeleteUser(event);
  //   } else {
  //     console.log('multi delete')
  //     this.handleDeleteMultipleUsers();
  //   }
  //   this.gridApi.deselectAll();
  //   this.setState({ openUserDeleteDialog: false });
  // };

  // handleDeleteUser = (event) => {
  //   this.setState({ loader: true });
  //   const selecRowID = this.state && this.state.selectedRowId;
  //   fetch(process.env.REACT_APP_BASEURL + "users/" + selecRowID, {
  //     method: "DELETE",
  //     withCredentials: true,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization:
  //         "Bearer " +
  //         JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
  //           .jwtToken,
  //     },
  //   }).then((results) => {
  //     this.setState({ loader: false });
  //     const _updatedUsers = this.state.data.filter(
  //       (x) => x.id !== this.state.selectedRowId
  //     );
  //     this.setState({
  //       data: JSON.parse(JSON.stringify(_updatedUsers)),
  //       selected: [],
  //       selectedRowId: null,
  //     });
  //   });
  // };

  // handleDeleteMultipleUsers = () => {
  //   this.setState({ loader: true });
  //   const result = fetch(
  //     process.env.REACT_APP_BASEURL +
  //     "users/" +
  //     this.state.selected.join(",").trim(","),
  //     {
  //       method: "DELETE",
  //       withCredentials: true,
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization:
  //           "Bearer " +
  //           JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
  //             .jwtToken,
  //       },
  //     }
  //   );
  //   result.then((result) => {
  //     this.setState({ loader: false });
  //     const newData = [];
  //     this.state.data.forEach((item) => {
  //       if (this.state.selected.indexOf(item.id) === -1) {
  //         newData.push(item);
  //       }
  //     });

  //     this.setState({
  //       data: JSON.parse(JSON.stringify(newData)),
  //       selected: [],
  //     });
  //   });
  // };

  render() {
    const { classes, t } = this.props;
    const { loader, data } = this.state;
    // const { openUserDeleteDialog, userDeletionArr, isHeaderChecked, selected } = this.state;

    const columnDefs = [
      {
        field: "picture_url", headerName: t("Report.inActive.Picture"), sortable: false, filter: false, cellRenderer: this.PictureCellRenderer,
      },
      { field: "name", headerName: t("Report.inActive.Name") },
      { field: "username", headerName: t("Report.inActive.UserName") },
      { field: "accountname", headerName: t("Report.inActive.AssociatedAccount") },
      { field: "phone", headerName: t("Report.inActive.Phone") },
      {
        field: "created_on", headerName: t("Report.inActive.CreatedOn"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.inActive.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.inActive.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      {
        field: "last_login_on", headerName: t("Report.inActive.LastLoginOn"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.inActive.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.inActive.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      { field: "is_enabled", headerName: t("Report.inActive.Status"), filter: false, sortable: false, cellRenderer: this.StatusCellRenderer(t) },
      {
        field: "actions", headerName: t("Report.inActive.Actions"), minWidth: 120, filter: false, sortable: false,
        cellRenderer: this.ActionCellRenderer(t, classes, data)
      },
    ];

    return (
      <Paper id="react-no-print" className={classes.root} >
        {
          loader ? (
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div>
          ) : null
        }
        {/* Start Delete Dialog.. */}
        {/*<Dialog
          open={openUserDeleteDialog || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Report.inActive.AreYouSureText")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("Report.inActive.AreYouSureBodyText")}
              <ul>
                {userDeletionArr &&
                  userDeletionArr.length > 0 &&
                  userDeletionArr.map((ele, index) => {
                    return <li key={index}>{ele && ele.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleConfirmClose}
              color="primary"
              className={classes.primaryButton}
            >
              {t("Report.inActive.CancelButton")}
            </Button>
            <Button
              onClick={this.handleDeleteConfirmed}
              color="primary"
              autoFocus
              className={classes.primaryButton}
            >
              {t("Report.inActive.DeleteButton")}
            </Button>
          </DialogActions>
        </Dialog>/*}
        {/* End Delete Dialog.. */}
        < div id="react-no-print" >
          <Box component="div">
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
              {/* <Grid item xs={3} md={3} sx={{ paddingLeft: '18px' }}>
                {isHeaderChecked || selected.length > 0 ? (
                  <span>
                    <Tooltip key='multi-delete' title={t("Report.inActive.DeleteTooltip")}>
                      <IconButton aria-label='Delete' onClick={this.handleConfirmDelete}
                        sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } })}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                    <Typography color='inherit' variant='subheading'>
                      {selected.length} {t("Report.inActive.SelectedRowCount")}
                    </Typography>
                  </span>
                ) : null}
              </Grid> */}
              <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                <Tooltip key="clear-filters" title={t("Report.inActive.ClearFiltersTooltip")}>
                  <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                    <CloseIcon style={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip key="export-csv" title={t("Report.inActive.ExportCSVTooltip")}>
                  <IconButton
                    style={{ marginRight: '0' }}
                    aria-label="ExportCSV"
                    disabled={this.state.isButtonDisabled}
                  >
                    <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
            <ReportsAGGrid
              columnDefs={columnDefs}
              sideBar={false}
              suppressMenuHide={true}
              defaultColDef={{
                flex: 1,
                minWidth: 150,
                floatingFilter: true,
                filter: 'agTextColumnFilter',
                filterParams: {
                  filterOptions: [{
                    displayKey: 'searchtext',
                    displayName: 'Search Text',
                    predicate: (cellValue) => cellValue
                  }],
                  maxNumConditions: 1,
                },
                resizable: true,
                sortable: true,
                menuTabs: ['generalMenuTab', 'columnsMenuTab'],

              }}
              onGridReady={this.onGridReady}
              getRowId={(params) => params.data.id}
              // onFirstDataRendered={this.onPageChanged}
              // onModelUpdated={this.onPageChanged}
              // onRowSelected={this.onRowSelected.bind(this)}
            />
          </Box>
        </div>
      </Paper >
    );
  }
}

UserInactiveReport.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(UserInactiveReport));



// WEBPACK FOOTER //
// ./src/components/reports/users-inactive-report/index.js